import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  reservationRoot: {
    marginBottom: 20,
  },
  blockTitle: {
    margin: 0,
    marginBottom: 15,
    fontSize: 19,
    fontWeight: 400,
    color: theme.custom.darkBlue,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  boxWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  dialogContainer: {
    marginTop: 70,
  },
}));
